const MOBILE = /^1[3456789]\d{9}$/

export default {
  // 验证手机号
  mobileAuthentication (mobile) {
    return MOBILE.test(mobile)
  },
  langText (status) {
    const sta = {
      zh: {
        text: '中文',
        national: require('@/assets/lang/zh.png'),
        start: require('@/assets/img/zh/submit.png'),
        bg: require('@/assets/img/zh/bg.png'),
        message: 'message',
        prizeName: 'prizeName',
        success: '恭喜您，提交成功！'
      },
      fr: {
        text: 'Frangais',
        national: require('@/assets/lang/fr.png'),
        start: require('@/assets/img/fr/submit.png'),
        bg: require('@/assets/img/fr/bg.png'),
        message: 'frenchMessage',
        prizeName: 'prizeFrenchName',
        success: 'Félicitations! Soumission réussie!'
      }
    }
    return sta[status]
  }
}
